import { Header } from "components/Header"
import { ar } from "i18n/ar"
import { BrandForm } from "@src/components/brand-form"

export default function CreateBrand() {
  return (
    <>
      <Header title={ar.newBrand} />
      <BrandForm onClose={() => {}} />
    </>
  )
}
